import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppService } from './app.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';

import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CustomMatPaginatorIntl } from './core/custom-paginator/custom-mat-paginator';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatPaginatorIntl } from '@angular/material';
import { MaterialModule } from './modules/material.module';

import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { initializer } from './utils/app-init';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AuthInterceptorService } from './services/utils/auth-interceptor.service';
import { CookieService } from 'ngx-cookie-service';
import { NotFoundComponent } from './not-found/not-found.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OrdersModule } from './layout/orders/orders.module';
import { TasksModule } from './layout/tasks/tasks.module';
import { LoaderInterceptorService } from './services/utils/loader-interceptor.service';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';

registerLocaleData(es);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    ForbiddenComponent,
  ],
  imports: [
    CoreModule,
    LayoutModule,
    OrdersModule,
    TasksModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    MaterialModule,
    LoggerModule.forRoot({ level: NgxLoggerLevel.TRACE }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    CookieService,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [KeycloakService, AppService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline'
      }
    },
  ],
  exports: [
    TranslateModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
